import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { change } from "redux-form";

import { feesHardcode } from "models";

import { withFeeBlockContext } from "../../feeBlockContext";
import TemplateField from "../../templateField";

const FeeMainBlock = ({
	validators,
	isMerchant,
	isEditApplication,
	isFiservFspProcessor,
	formName,
	isMerchantFeesPage,
	isPaperApplication,
}) => {
	const dispatch = useDispatch();
	useEffect(() => {
		if (!isMerchant && !isEditApplication) {
			dispatch(
				change(formName, "retrievalFee", feesHardcode.retrievalFee),
			);
			if (isFiservFspProcessor) {
				dispatch(change(formName, "avs", feesHardcode.avs));
				dispatch(change(formName, "aru", feesHardcode.aru));
				dispatch(change(formName, "voiceAuth", feesHardcode.voiceAuth));
				dispatch(change(formName, "voiceAVS", feesHardcode.voiceAVS));
				dispatch(
					change(
						formName,
						"gatewayPerAuth",
						feesHardcode.gatewayPerAuth,
					),
				);
			} else {
				dispatch(change(formName, "avs", ""));
				dispatch(change(formName, "aru", ""));
				dispatch(change(formName, "voiceAuth", ""));
				dispatch(change(formName, "voiceAVS", ""));
				dispatch(change(formName, "gatewayPerAuth", ""));
			}
		}
	}, [
		dispatch,
		formName,
		isEditApplication,
		isFiservFspProcessor,
		isMerchant,
	]);

	return (
		<Row>
			<Col md={5}>
				<TemplateField
					name="authorizationFee"
					label="Authorization Fee, $"
					placeholder="0.000000"
					placeholderClassName={
						isPaperApplication
							? "placeholder-value"
							: "placeholder-primary"
					}
					{...validators.authorizationFee}
					hideRequiredMark={isPaperApplication}
				/>
				<TemplateField
					name="avs"
					label="AVS, $"
					placeholder="0.000000"
					placeholderClassName={
						isPaperApplication
							? "placeholder-value"
							: "placeholder-primary"
					}
					{...validators.avs}
					disabled={!isMerchant && isFiservFspProcessor}
					isPlainText={!isMerchant && isFiservFspProcessor}
					hideRequiredMark={isPaperApplication}
				/>
				<TemplateField
					name="aru"
					label="ARU, $"
					placeholder="0.000000"
					placeholderClassName={
						isPaperApplication
							? "placeholder-value"
							: "placeholder-primary"
					}
					{...validators.aru}
					disabled={!isMerchant && isFiservFspProcessor}
					isPlainText={!isMerchant && isFiservFspProcessor}
					hideRequiredMark={isPaperApplication}
				/>
				<TemplateField
					name="batchSettlement"
					label="Batch Settlement, $"
					placeholder="0.000000"
					placeholderClassName={
						isPaperApplication
							? "placeholder-value"
							: "placeholder-primary"
					}
					{...validators.batchSettlement}
					hideRequiredMark={isPaperApplication}
				/>
				<TemplateField
					name="additionalFeeOtherItemFee"
					label="Other Item, $"
					placeholder="0.000000"
					placeholderClassName={
						isPaperApplication
							? "placeholder-value"
							: "placeholder-primary"
					}
					{...validators.additionalFeeOtherItemFee}
					hideRequiredMark={isPaperApplication}
				/>
				{isMerchantFeesPage && (
					<TemplateField
						name="riseFreeTransFee"
						label="Rise Free Trans Fee, $"
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						{...validators.riseFreeTransFee}
						hideRequiredMark={isPaperApplication}
					/>
				)}
			</Col>
			<Col md={{ span: 5, offset: 2 }}>
				<TemplateField
					name="salesTransactionFee"
					label="Sales Transaction Fee, $"
					placeholder="0.000000"
					placeholderClassName={
						isPaperApplication
							? "placeholder-value"
							: "placeholder-primary"
					}
					{...validators.salesTransactionFee}
					hideRequiredMark={isPaperApplication}
				/>
				<TemplateField
					name="voiceAuth"
					label="Voice Auth, $"
					placeholder="0.000000"
					placeholderClassName={
						isPaperApplication
							? "placeholder-value"
							: "placeholder-primary"
					}
					{...validators.voiceAuth}
					disabled={!isMerchant && isFiservFspProcessor}
					isPlainText={!isMerchant && isFiservFspProcessor}
					hideRequiredMark={isPaperApplication}
				/>
				<TemplateField
					name="voiceAVS"
					label="Voice AVS, $"
					placeholder="0.000000"
					placeholderClassName={
						isPaperApplication
							? "placeholder-value"
							: "placeholder-primary"
					}
					{...validators.voiceAVS}
					disabled={!isMerchant && isFiservFspProcessor}
					isPlainText={!isMerchant && isFiservFspProcessor}
					hideRequiredMark={isPaperApplication}
				/>
				<TemplateField
					name="otherVolume"
					label="Other Volume, %"
					placeholder="0.000000"
					placeholderClassName={
						isPaperApplication
							? "placeholder-value"
							: "placeholder-primary"
					}
					{...validators.otherVolume}
					hideRequiredMark={isPaperApplication}
				/>
				<TemplateField
					name="returnTransactionFee"
					label="Return Transaction, $"
					placeholder="0.000000"
					placeholderClassName={
						isPaperApplication
							? "placeholder-value"
							: "placeholder-primary"
					}
					{...validators.returnTransactionFee}
					hideRequiredMark={isPaperApplication}
				/>
				<TemplateField
					name="retrievalFee"
					label="Retrieval Fee, $"
					placeholder="0.000000"
					placeholderClassName={
						isPaperApplication
							? "placeholder-value"
							: "placeholder-primary"
					}
					{...validators.retrievalFee}
					disabled={!isMerchant}
					isPlainText={!isMerchant}
					hideRequiredMark={isPaperApplication}
				/>
			</Col>
		</Row>
	);
};

export default withFeeBlockContext("FeeMain")(FeeMainBlock);
